import { colors } from "../theme/foundations/colors";

/**
 * How far through the workflow a question is, as a percentage and a colour.
 *
 * Keyed on `stageType`, the enum, never on `stage` — the stage NAME is editable per round and comes from the
 * database, so a layout keyed on it breaks the first time somebody renames "Ready for Audit".
 *
 * The three-bucket colour rule is deliberately coarser than `colors.stages`, which has a distinct colour for
 * all nine stages: on a progress bar the question is "is this done, moving, or not started", and nine colours
 * answer a question nobody asked.
 *
 * Foundation Data v1 carries two copies of this table (`FoundationDataPage` and `OtherYearCards`). They are
 * left alone on purpose — v1 is a parallel system v2 does not edit — but v2's two consumers share this one
 * rather than adding a third and a fourth.
 */
export const STAGE_PROGRESS = {
  START: 10,
  AI_QUEUE: 15,
  EXPERT_REVIEW: 25,
  PENDING: 10,
  IN_PROGRESS: 50,
  INTERNAL_REVIEW: 70,
  AUDIT: 85,
  COMPLETE: 100,
};

/** An unknown or missing stage reads as barely started rather than as complete. */
export const PROGRESS_FLOOR = 10;

export function progressOf(stageType) {
  return STAGE_PROGRESS[stageType] ?? PROGRESS_FLOOR;
}

export function getProgressColor(stageType) {
  if (stageType === "COMPLETE" || stageType === "AUDIT") return colors.stages.COMPLETE;
  if (stageType === "IN_PROGRESS" || stageType === "INTERNAL_REVIEW") return colors.stages.IN_PROGRESS;
  return "#E53E3E";
}

/**
 * A dashed fill for a finished stage, so "complete" is distinguishable from "nearly complete" without
 * reading the label — the two are four pixels apart on a full-width bar.
 */
export function getProgressStyle(stageType) {
  if (stageType !== "COMPLETE") return {};
  return {
    background: `repeating-linear-gradient(
        90deg,
        ${colors.stages.COMPLETE} 0px,
        ${colors.stages.COMPLETE} 8px,
        transparent 8px,
        transparent 12px
      )`,
  };
}
